import React from 'react'
import BrowseMenu from '../../BrowseMenu'
import useClickOutside from '#src/hooks/useClickOutside'
import { ContainedNavItemProps } from '../'
import styles from '../styles.css'

const BrowseNavItem: React.FC<ContainedNavItemProps> = ({
  children,
  onNavItemClicked,
  onNavItemClickedAway,
  isNavItemActive
}) => {
  const liRef = useClickOutside<HTMLLIElement>(() => {
    if (isNavItemActive) {
      onNavItemClickedAway()
    }
  })

  return (
    <li
      ref={liRef}
      className={styles.navItem}
      onClick={() => {
        onNavItemClicked()
      }}
    >
      <span className={styles.navItemLink}>
        <div className={styles.navItemHighlight}>{children}</div>
      </span>
      {isNavItemActive && <BrowseMenu />}
    </li>
  )
}

export default BrowseNavItem
